import React from 'react'
import Banner from './Banner'
import HomeContent from './HomeContent'
import VirtualTour from './VirtualTour'
import News from './News'
import ServicesHome from './ServicesHome'
import HomeFleet from './HomeFleet'

import './home.css';
import HomeBlog from './HomeBlog'

function Home() {
  return (
    <div  className="mt-100">
      <Banner></Banner>
      <HomeContent/>
      {/* <VirtualTour/>
      <News></News>
      <ServicesHome/>
      <HomeFleet/>
      <HomeBlog/> */}
    </div>
  )
}

export default Home
